/* =====================================================================
   LIVFRESH Buy Box — Replo-portable, vanilla JS (no framework deps)
   Upload this file to Shopify Files and load via:
     {{ 'ai-buybox.js' | file_url | script_tag }}
   Config is read from window.AI_BUYBOX_CONFIG. See replo-snippet.html.

   Connects to product backend exactly like the live LIVFRESH PDP:
     1. POST /cart/add.js with { id: variantId, selling_plan?: id }
     2. Call window.openCart() to open the theme's mini-cart drawer
        (with a /cart fallback if the helper is unavailable).
   ===================================================================== */

(function () {
  'use strict';

  var ROOT_SELECTOR = '.ai-buybox';
  var instances = [];

  /* ---------------- helpers ---------------- */

  function formatMoney(n) {
    return '$' + Number(n).toFixed(2);
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        var v = attrs[k];
        if (v == null || v === false) continue;
        if (k === 'class') node.className = v;
        else if (k === 'html') node.innerHTML = v;
        else if (k === 'text') node.textContent = v;
        else if (k === 'dataset') {
          for (var dk in v) { if (v[dk] != null) node.dataset[dk] = v[dk]; }
        } else if (k.indexOf('on') === 0 && typeof v === 'function') {
          node.addEventListener(k.slice(2), v);
        } else if (v === true) {
          node.setAttribute(k, '');
        } else {
          node.setAttribute(k, v);
        }
      }
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c == null || c === false) return;
        node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return node;
  }

  /* ---------------- cart wiring ---------------- */

  function addToCart(variantId, sellingPlanId) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var item = { id: variantId, quantity: 1 };
    if (sellingPlanId) item.selling_plan = sellingPlanId;

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (t) { throw new Error('cart/add.js ' + res.status + ': ' + t); });
      }
      return res.json();
    });
  }

  function openCartDrawer() {
    if (typeof window.openCart === 'function') {
      try { window.openCart(); return true; } catch (e) { /* fall through */ }
    }
    // Fallback for environments without the theme helper
    var dialog = document.getElementById('miniCart');
    if (dialog && typeof dialog.showModal === 'function') {
      try { dialog.showModal(); return true; } catch (e) { /* fall through */ }
    }
    window.location.href = '/cart';
    return false;
  }

  /* ---------------- tube renderer ---------------- */

  function tubeViz(cfg, card) {
    var paid = card.tubeCountPaid || 1;
    var free = card.tubeCountFree || 0;
    var src = cfg.tubeImageUrl;

    // If the card has a pre-composited image (e.g. a pre-rendered "buy 2 get 1
    // free" graphic), render just that single <img> and skip the per-tube
    // overlap layout entirely. Used in the narrow PDP column where stacking
    // 3 paid + 2 free tubes side-by-side with negative margins doesn't fit.
    if (card.compositeImageUrl) {
      return [
        el('img', {
          class: 'aib-tube-composite',
          src: card.compositeImageUrl,
          alt: card.compositeImageAlt || (card.leadLabel + ' bundle')
        })
      ];
    }

    function tube(opts) {
      opts = opts || {};
      var height = opts.height || 400;
      var marginLeft = opts.marginLeft;
      var isFree = !!opts.free;
      var stamp = isFree && opts.stamp ? el('span', { class: 'aib-free-stamp', text: 'FREE' }) : null;
      var img = el('img', { src: src, alt: 'LIVFRESH tube' + (isFree ? ' (free)' : ''), style: 'height:' + height + 'px' });
      var span = el('span', { class: 'aib-tube', style: 'height:' + height + 'px' + (marginLeft != null ? ';margin-left:' + marginLeft + 'px' : '') }, [img, stamp]);
      return span;
    }

    // 1 paid, 0 free — single big tube
    if (paid === 1 && free === 0) {
      return [
        el('div', { class: 'aib-tube-group' }, [tube({ height: 420 })])
      ];
    }

    // 2 paid, 1 free — two stacked + one free with FREE stamp
    if (paid === 2 && free === 1) {
      var H = 400, OL = -280;
      return [
        el('div', { class: 'aib-tube-group' }, [
          tube({ height: H }),
          tube({ height: H, marginLeft: OL })
        ]),
        el('div', { class: 'aib-tube-divider', 'aria-hidden': 'true', text: '+' }),
        el('div', { class: 'aib-tube-group' }, [
          tube({ height: H, free: true, stamp: true })
        ])
      ];
    }

    // Generic n paid + m free — used for 3 paid + 2 free
    var H2 = 400, OL2 = -325;
    var paidGroup = el('div', { class: 'aib-tube-group' });
    for (var i = 0; i < paid; i++) {
      paidGroup.appendChild(tube({ height: H2, marginLeft: i === 0 ? null : OL2 }));
    }
    var freeGroup = el('div', { class: 'aib-tube-group' });
    for (var j = 0; j < free; j++) {
      freeGroup.appendChild(tube({ height: H2, marginLeft: j === 0 ? null : OL2, free: true, stamp: j === free - 1 }));
    }
    return [paidGroup, el('div', { class: 'aib-tube-divider', 'aria-hidden': 'true', text: '+' }), freeGroup];
  }

  /* ---------------- card builder ---------------- */

  function buildCard(instance, card, idx) {
    var kindClass = card.tagStyle === 'entry' ? 'is-entry'
                  : card.tagStyle === 'popular' ? 'is-popular'
                  : card.tagStyle === 'best' ? 'is-best' : '';

    var bundle = el('button', {
      type: 'button',
      class: 'aib-bundle ' + kindClass,
      dataset: { cardId: card.id, cardIndex: idx },
      'aria-pressed': 'false'
    });

    // Header tag — content swaps with mode (see renderCards). Default text below
    // is just the initial paint; the actual rendered string comes from the
    // mode-aware logic in renderCards().
    var headerTag = el('div', { class: 'aib-header-tag', text: card.headerTag || '' });
    bundle.appendChild(headerTag);

    // Selection radio
    bundle.appendChild(el('span', { class: 'aib-radio-dot', 'aria-hidden': 'true' }));

    var body = el('div', { class: 'aib-body' });

    // Tube area
    var tubeArea = el('div', { class: 'aib-tube-area' }, tubeViz(instance.cfg, card));
    body.appendChild(tubeArea);

    // Copy block (lead + ship line)
    var lead = el('div', { class: 'aib-lead' });
    lead.appendChild(document.createTextNode(card.leadLabel || ''));
    if (card.tubeCountFree > 0) {
      lead.appendChild(document.createTextNode(' '));
      lead.appendChild(el('span', { class: 'aib-lead-free', text: 'FREE' }));
    }
    var subLine = el('div', { class: 'aib-sub', text: card.ship || '' });
    var copy = el('div', { class: 'aib-copy' }, [ lead, subLine ]);
    body.appendChild(copy);

    // Save chip (text + visibility updated on render)
    var saveChip = el('div', { class: 'aib-save-chip', text: '' });
    body.appendChild(saveChip);

    // Prices (text updated on render)
    var priceNow = el('span', { class: 'aib-price-now', text: '' });
    var priceWas = el('span', { class: 'aib-price-was', text: '' });
    body.appendChild(el('div', { class: 'aib-prices' }, [priceNow, priceWas]));

    // Per-brushing (text updated on render)
    var perUnit = el('div', { class: 'aib-per-unit', text: '' });
    body.appendChild(perUnit);

    // Shipping note
    if (card.shipping) {
      var note = el('div', { class: 'aib-shipping-note' + (card.shipping.free ? ' is-free' : ''), 'data-shipping': card.shipping.free ? 'free' : 'paid' });
      if (card.shipping.free) {
        note.appendChild(el('span', { class: 'aib-shipping-truck', 'aria-hidden': 'true', text: '→' }));
        note.appendChild(document.createTextNode(' ' + (card.shipping.label || 'FREE Shipping included')));
      } else {
        note.textContent = card.shipping.label || 'Shipping not included';
      }
      body.appendChild(note);
    }

    // Optional urgency banner at the bottom of the card body.
    // Breaks out of the body's horizontal padding to span edge-to-edge.
    // Visibility per mode is decided in renderCards via `showOnlyInModes`.
    var urgencyEl = null;
    if (card.urgencyBanner) {
      urgencyEl = el('div', { class: 'aib-urgency' });
      var tag = el('div', { class: 'aib-urgency-tag' });
      // iconType "alert" → pulsing red-bordered white circle with "!" inside.
      // Otherwise, fall back to a plain text/emoji icon if `icon` is provided.
      if (card.urgencyBanner.iconType === 'alert') {
        tag.appendChild(el('span', { class: 'aib-urgency-alert', 'aria-hidden': 'true', text: '!' }));
      } else if (card.urgencyBanner.icon) {
        tag.appendChild(el('span', { class: 'aib-urgency-icon', 'aria-hidden': 'true', text: card.urgencyBanner.icon }));
      }
      tag.appendChild(document.createTextNode(' ' + (card.urgencyBanner.tag || 'SELLING OUT')));
      urgencyEl.appendChild(tag);
      if (card.urgencyBanner.body) {
        urgencyEl.appendChild(el('div', { class: 'aib-urgency-body', text: card.urgencyBanner.body }));
      }
      body.appendChild(urgencyEl);
    }

    bundle.appendChild(body);

    bundle.addEventListener('click', function () { setSelected(instance, card.id); });

    // Expose mutable refs on the node so render() can update without re-creating.
    // tubeComposite: the <img class="aib-tube-composite"> if this card uses a
    // pre-composited image. Captured so we can swap src per mode (subscribe
    // image with FREE markings vs onetime image with just the tubes).
    var tubeComposite = tubeArea.querySelector('.aib-tube-composite');
    bundle._aib = {
      headerTag: headerTag,
      lead: lead,
      sub: subLine,
      saveChip: saveChip,
      priceNow: priceNow,
      priceWas: priceWas,
      perUnit: perUnit,
      urgency: urgencyEl,
      tubeComposite: tubeComposite
    };
    return bundle;
  }

  // Given a subscribe-mode composite image URL like
  //   https://cdn.shopify.com/.../ai-buybox-card-3pack.png?v=123
  // return the onetime-mode equivalent
  //   https://cdn.shopify.com/.../ai-buybox-card-3pack-onetime.png?v=123
  // by inserting `-onetime` before the `.png` extension. Returns the input
  // unchanged if the URL doesn't have a `.png` (handles edge cases gracefully).
  function onetimeImageUrl(url) {
    if (!url) return url;
    return url.replace(/\.png(\?|$)/i, '-onetime.png$1')
              .replace(/\.jpg(\?|$)/i, '-onetime.jpg$1')
              .replace(/\.jpeg(\?|$)/i, '-onetime.jpeg$1');
  }

  /* ---------------- subscribe benefits panel ---------------- */

  function buildBenefits(instance) {
    var cfg = instance.cfg;
    var b = cfg.benefits || {};
    var panel = el('div', { class: 'aib-sub-benefits', hidden: true });

    panel.appendChild(el('span', { class: 'aib-sub-icon', 'aria-hidden': 'true', text: b.icon || '↻' }));

    var heading = el('div', null, [
      el('h4', { class: 'aib-sub-title' }),
      el('div', { class: 'aib-sub-desc', text: b.description || 'Get LIVFRESH delivered on your schedule. Pause, edit or cancel from your account.' })
    ]);
    panel.appendChild(heading);

    var list = el('ul', { class: 'aib-sub-list' });
    var rawItems = b.items || [
      { text: '24Hr Early Access: Sales & New Arrivals' },
      { text: '90-Day 100% Money-Back Guarantee*' },
      { text: 'Invitation to Our Private VIP Wellness Club' },
      { text: 'Pause, Skip & Cancel at Anytime' }
    ];
    rawItems.forEach(function (item) {
      var li = el('li', { dataset: { requiresMultiPack: item.requiresMultiPack ? '1' : '' }, text: item.text });
      list.appendChild(li);
    });
    panel.appendChild(list);

    panel._aib = { title: heading.querySelector('.aib-sub-title'), list: list };
    return panel;
  }

  /* ---------------- welcome gifts ---------------- */

  // Inline SVG icons used when a gift has iconType instead of imageUrl.
  // Currently supports "truck" (free shipping). Adding more is one entry each.
  var GIFT_ICON_SVGS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
           '<path d="M3 16V6h11v10"/><path d="M14 9h4l3 4v3h-7"/>' +
           '<circle cx="7.5" cy="17.5" r="2"/><circle cx="17.5" cy="17.5" r="2"/>' +
           '</svg>'
  };
  var LOCK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
                 '<rect x="5" y="11" width="14" height="9" rx="2"/>' +
                 '<path d="M8 11V8a4 4 0 0 1 8 0v3"/>' +
                 '</svg>';

  function buildWelcomeGifts(instance) {
    var cfg = instance.cfg;
    if (!cfg.welcomeGifts || !Array.isArray(cfg.welcomeGifts.gifts) || !cfg.welcomeGifts.gifts.length) {
      return null;
    }
    var section = el('section', {
      class: 'aib-welcome-gifts',
      'aria-label': cfg.welcomeGifts.title || 'Limited time free welcome gifts'
    });
    section.appendChild(el('h3', { text: cfg.welcomeGifts.title || 'Limited Time Free Welcome Gifts' }));

    var track = el('div', { class: 'aib-gift-track' });
    var rail = el('div', { class: 'aib-gift-rail', 'aria-hidden': 'true' });
    track.appendChild(rail);

    var giftNodes = cfg.welcomeGifts.gifts.map(function (g) {
      var card = el('article', { class: 'aib-gift-card', dataset: { giftId: g.id } });
      card.appendChild(el('div', { class: 'aib-gift-name', text: g.name || '' }));

      var imgWrap = el('div', { class: 'aib-gift-img', 'aria-hidden': 'true' });
      // Inner content slot — refreshed on render() so the multi-tube image
      // for Bonus Tube can swap between 1 and 2 tubes depending on selection.
      var content = el('span', { class: 'aib-gift-img-content', style: 'display:contents' });
      imgWrap.appendChild(content);
      // Lock overlay (hidden when unlocked)
      var lock = el('span', { class: 'aib-lock-overlay', html: LOCK_SVG, hidden: true });
      imgWrap.appendChild(lock);
      card.appendChild(imgWrap);

      var save = el('div', { class: 'aib-gift-save' });
      var strike = el('span', { class: 'aib-strike', text: g.saveLabel || (g.save ? 'Save $' + g.save : '') });
      var freeLabel = el('span', { class: 'aib-free' });
      save.appendChild(strike);
      save.appendChild(freeLabel);
      card.appendChild(save);

      card._aib = { gift: g, content: content, lock: lock, freeLabel: freeLabel, strike: strike };
      track.appendChild(card);
      return card;
    });

    section.appendChild(track);
    section._aib = { track: track, rail: rail, giftNodes: giftNodes };
    return section;
  }

  // Decide whether a gift is unlocked for the current (card, mode) pair.
  // A gift's `unlockedFor.cards` and `unlockedFor.modes` arrays act as
  // allow-lists; both must match (or be omitted, which means "any").
  function isGiftUnlocked(gift, selectedId, mode) {
    if (!gift.unlockedFor) return true;
    var rule = gift.unlockedFor;
    var cardOK = !rule.cards || rule.cards.indexOf(selectedId) !== -1;
    var modeOK = !rule.modes || rule.modes.indexOf(mode) !== -1;
    return cardOK && modeOK;
  }

  function renderWelcomeGifts(instance) {
    var section = instance.dom.welcomeGifts;
    if (!section) return;
    var selectedId = instance.state.selectedId;
    var mode = instance.state.mode;

    // Count unlocked gifts so the rail fill (driven by --aib-unlocked) is accurate.
    var unlockedCount = 0;
    section._aib.giftNodes.forEach(function (node) {
      if (isGiftUnlocked(node._aib.gift, selectedId, mode)) unlockedCount++;
    });
    section._aib.track.style.setProperty('--aib-unlocked', String(unlockedCount));

    section._aib.giftNodes.forEach(function (node, i) {
      var g = node._aib.gift;
      var isUnlocked = isGiftUnlocked(g, selectedId, mode);
      node.classList.toggle('is-locked', !isUnlocked);
      node._aib.lock.hidden = isUnlocked;
      node._aib.freeLabel.textContent = isUnlocked ? 'FREE' : 'LOCKED';

      // Render image content — swap 1↔2 tubes for Bonus Tube based on selected card
      var content = node._aib.content;
      content.innerHTML = '';
      var multi = 1;
      if (g.multiByCard && selectedId in g.multiByCard) {
        multi = g.multiByCard[selectedId];
      }

      // Dynamic strike label: if gift has a numeric unitPrice, recompute the
      // "Save $X" label per selection as unitPrice × multi. Lets the Bonus
      // Tube show $34.99 on 3-pack and $69.98 on 5-pack (1×$34.99 / 2×$34.99)
      // without per-pack hardcoded labels. Falls back to the static saveLabel
      // when unitPrice is not provided.
      if (node._aib.strike && typeof g.unitPrice === 'number') {
        var totalSave = g.unitPrice * multi;
        // Drop trailing .00 for whole dollars; keep cents otherwise.
        var totalStr = (Math.round(totalSave * 100) / 100).toFixed(2);
        if (totalStr.slice(-3) === '.00') totalStr = totalStr.slice(0, -3);
        node._aib.strike.textContent = 'Save $' + totalStr;
      }

      if (g.iconType && GIFT_ICON_SVGS[g.iconType]) {
        // Inline SVG icon (e.g. truck for Free Shipping)
        var wrap = el('span', { html: GIFT_ICON_SVGS[g.iconType], style: 'display:contents' });
        content.appendChild(wrap);
      } else if (g.imageUrl) {
        if (multi >= 2) {
          var pair = el('div', { class: 'aib-tube-pair' });
          for (var k = 0; k < multi; k++) pair.appendChild(el('img', { src: g.imageUrl, alt: '' }));
          content.appendChild(pair);
        } else {
          content.appendChild(el('img', { src: g.imageUrl, alt: '' }));
        }
      }
    });
  }

  /* ---------------- mode tabs ---------------- */

  function buildModeTabs(instance) {
    var cfg = instance.cfg;
    var subDiscount = cfg.subDiscountPercent != null ? cfg.subDiscountPercent : 40;
    var tabs = el('div', { class: 'aib-mode-tabs', role: 'tablist' });
    var indicator = el('div', { class: 'aib-mode-indicator' });
    var oneTime = el('button', {
      type: 'button',
      class: 'aib-mode-tab',
      role: 'tab',
      'aria-selected': 'false',
      dataset: { mode: 'onetime' },
      text: cfg.copy && cfg.copy.oneTimeTab ? cfg.copy.oneTimeTab : 'One-Time Purchase'
    });
    // Subscribe tab label: split on " + " (or " +") so the bonus portion
    // ("+ A Free Gift") sits in a .aib-tab-bonus span that we can stack on
    // its own line on mobile via CSS (display:block at ≤600px).
    // Falls back to plain rendering if the label has no " +" suffix.
    var rawSubscribe = (cfg.copy && cfg.copy.subscribeTab)
      ? cfg.copy.subscribeTab
      : 'Subscribe & Save Up To ' + subDiscount + '% + A Free Gift';
    function escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function buildSubscribeLabel(text) {
      var idx = text.indexOf(' +');
      if (idx === -1) return escapeHtml(text);
      var head = text.slice(0, idx);
      var bonus = text.slice(idx).replace(/^\s+/, ''); // drop leading space, keep "+ A Free Gift"
      return escapeHtml(head) + ' <span class="aib-tab-bonus">' + escapeHtml(bonus) + '</span>';
    }
    var subscribe = el('button', {
      type: 'button',
      class: 'aib-mode-tab',
      role: 'tab',
      'aria-selected': 'false',
      dataset: { mode: 'subscribe' }
    });
    subscribe.innerHTML = buildSubscribeLabel(rawSubscribe);
    tabs.appendChild(indicator);
    tabs.appendChild(oneTime);
    tabs.appendChild(subscribe);

    oneTime.addEventListener('click', function () { setMode(instance, 'onetime'); });
    subscribe.addEventListener('click', function () { setMode(instance, 'subscribe'); });

    tabs._aib = { indicator: indicator, oneTime: oneTime, subscribe: subscribe };
    return tabs;
  }

  /* ---------------- trust badges (below CTA) ---------------- */

  // Compact SVGs for brand logos. Each is hand-curated to be small and
  // recognizable at ~28px height. White card background, brand-colored content.
  var PAYMENT_SVGS = {
    // AMEX: official-blue background with "AMERICAN EXPRESS" mark
    amex: '<svg viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="36" rx="4" fill="#1F72CD"/><text x="30" y="17" font-family="Helvetica,Arial,sans-serif" font-size="6.5" font-weight="900" fill="#fff" text-anchor="middle" letter-spacing="0.4">AMERICAN</text><text x="30" y="25" font-family="Helvetica,Arial,sans-serif" font-size="6.5" font-weight="900" fill="#fff" text-anchor="middle" letter-spacing="0.4">EXPRESS</text></svg>',
    // Apple Pay: real apple silhouette + "Pay"
    applepay: '<svg viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg"><rect x="0.75" y="0.75" width="58.5" height="34.5" rx="4" fill="#fff" stroke="#000" stroke-width="1.5"/><path d="M19.4 13.2c-.5.7-1.4 1.1-2.2 1.1-.1-.9.3-1.7.8-2.3.5-.6 1.4-1 2.1-1.1.1.9-.3 1.7-.7 2.3zm.8 1.1c-1.2-.07-2.2.66-2.7.66-.6 0-1.5-.63-2.4-.62-1.2.02-2.3.7-2.9 1.8-1.3 2.2-.3 5.5 1 7.3.6.9 1.3 1.85 2.2 1.83.9-.04 1.2-.6 2.3-.6 1.1 0 1.4.6 2.4.58.95-.03 1.55-.88 2.13-1.77.55-.8.9-1.78.93-1.84-.02-.01-1.85-.71-1.86-2.83-.02-1.77 1.45-2.62 1.51-2.66-.83-1.22-2.13-1.36-2.6-1.4z" fill="#000"/><text x="34" y="22.5" font-family="Helvetica,Arial,sans-serif" font-size="11" font-weight="600" fill="#000">Pay</text></svg>',
    // Diners Club: classic two-tone interlocking semicircles
    diners: '<svg viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="36" rx="4" fill="#fff" stroke="#e5e7eb"/><circle cx="20" cy="18" r="10" fill="#0079BE"/><path d="M20 9 a 9 9 0 0 1 0 18 z" fill="#fff"/><circle cx="20" cy="18" r="10" fill="none" stroke="#0079BE" stroke-width="1.5"/><circle cx="16" cy="18" r="3" fill="#fff"/><circle cx="24" cy="18" r="3" fill="#0079BE"/><text x="34" y="22" font-family="Helvetica,Arial,sans-serif" font-size="7" font-weight="700" fill="#0079BE">Diners</text></svg>',
    // Discover: "DISCOVER" text + orange "tropical sun" mark
    discover: '<svg viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="36" rx="4" fill="#fff" stroke="#e5e7eb"/><text x="29" y="20" font-family="Helvetica,Arial,sans-serif" font-size="8.5" font-weight="900" fill="#000" text-anchor="middle" letter-spacing="-0.2">DISCOVER</text><path d="M3 22 Q 30 30 57 22 L 57 30 Q 30 36 3 30 Z" fill="#F7941D"/></svg>',
    // Google Pay: multi-color G + dark "Pay"
    gpay: '<svg viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="36" rx="4" fill="#fff" stroke="#e5e7eb"/><g transform="translate(10 10) scale(0.65)"><path d="M24 12.27c0-.79-.07-1.54-.2-2.27H12.24v4.3h6.6c-.28 1.54-1.15 2.85-2.45 3.72v3.09h3.97c2.32-2.14 3.66-5.3 3.66-9.04z" fill="#4285F4"/><path d="M12.24 24c3.32 0 6.1-1.1 8.13-2.99l-3.97-3.09c-1.1.74-2.51 1.18-4.16 1.18-3.2 0-5.91-2.16-6.88-5.06H1.27v3.18C3.29 21.3 7.45 24 12.24 24z" fill="#34A853"/><path d="M5.36 14.04c-.25-.74-.39-1.53-.39-2.34 0-.81.14-1.6.39-2.34V6.18H1.27C.46 7.8 0 9.65 0 11.7s.46 3.9 1.27 5.52l4.09-3.18z" fill="#FBBC05"/><path d="M12.24 4.7c1.81 0 3.43.62 4.7 1.84l3.53-3.53C18.34 1.19 15.55 0 12.24 0 7.45 0 3.29 2.7 1.27 6.18l4.09 3.18c.97-2.9 3.68-5.06 6.88-5.06z" fill="#EA4335"/></g><text x="35" y="22" font-family="Helvetica,Arial,sans-serif" font-size="10" font-weight="600" fill="#5F6368">Pay</text></svg>',
    // Mastercard: classic overlapping red + orange circles, no text
    mastercard: '<svg viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="36" rx="4" fill="#fff" stroke="#e5e7eb"/><circle cx="25" cy="18" r="9.5" fill="#EB001B"/><circle cx="35" cy="18" r="9.5" fill="#F79E1B"/><path d="M30 10.6 a 9.5 9.5 0 0 1 0 14.8 9.5 9.5 0 0 1 0 -14.8 Z" fill="#FF5F00"/></svg>',
    // PayPal: italic two-tone "PayPal" (dark blue + sky blue)
    paypal: '<svg viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="36" rx="4" fill="#fff" stroke="#e5e7eb"/><text x="6" y="24" font-family="Helvetica,Arial,sans-serif" font-size="13" font-weight="900" fill="#003087" font-style="italic" letter-spacing="-0.5">Pay</text><text x="29" y="24" font-family="Helvetica,Arial,sans-serif" font-size="13" font-weight="900" fill="#009CDE" font-style="italic" letter-spacing="-0.5">Pal</text></svg>',
    // Shop Pay: Shopify-purple background with white "shop"
    shoppay: '<svg viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="36" rx="4" fill="#5A31F4"/><text x="30" y="23" font-family="Helvetica,Arial,sans-serif" font-size="12" font-weight="900" fill="#fff" text-anchor="middle" letter-spacing="-0.3">shop</text></svg>',
    // Visa: italic blue "VISA" wordmark
    visa: '<svg viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="36" rx="4" fill="#fff" stroke="#e5e7eb"/><text x="30" y="25" font-family="Arial Black,Helvetica,sans-serif" font-size="16" font-weight="900" fill="#1A1F71" text-anchor="middle" font-style="italic" letter-spacing="-0.5">VISA</text></svg>'
  };

  /* Trust claim icons — drawn at 18px in CSS via currentColor */
  var TRUST_ICON_GUARANTEE = '<svg class="aib-trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 4 5v6c0 5 3.5 9.5 8 11 4.5-1.5 8-6 8-11V5l-8-3z"/><polyline points="9 12 11 14 15 10"/></svg>';
  var TRUST_ICON_SHIPPING  = '<svg class="aib-trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="13" height="11" rx="1"/><path d="M14 9h4l3 3v5h-7V9z"/><circle cx="6" cy="19" r="2"/><circle cx="17" cy="19" r="2"/></svg>';
  var TRUST_ICON_SECURE    = '<svg class="aib-trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';

  function buildTrustBadges(instance) {
    if (instance.cfg.hideTrustBadges) return null;
    var wrap = el('div', { class: 'aib-trust' });

    var claims = el('div', { class: 'aib-trust-claims' });
    claims.appendChild(el('span', { class: 'aib-trust-claim', html: TRUST_ICON_GUARANTEE + '<span>90-Day Money-Back Guarantee</span>' }));
    claims.appendChild(el('span', { class: 'aib-trust-divider', text: '|' }));
    claims.appendChild(el('span', { class: 'aib-trust-claim', html: TRUST_ICON_SHIPPING + '<span>Fast Shipping + Easy Returns</span>' }));
    claims.appendChild(el('span', { class: 'aib-trust-divider', text: '|' }));
    claims.appendChild(el('span', { class: 'aib-trust-claim', html: TRUST_ICON_SECURE + '<span>Safe &amp; Secure Checkout</span>' }));
    wrap.appendChild(claims);

    var payments = el('div', { class: 'aib-trust-payments' });
    var order = ['amex','applepay','discover','gpay','mastercard','paypal','shoppay','visa'];
    order.forEach(function (brand) {
      payments.appendChild(el('span', { class: 'aib-trust-payment', dataset: { brand: brand }, html: PAYMENT_SVGS[brand] }));
    });
    wrap.appendChild(payments);

    return wrap;
  }

  /* ---------------- 90-Day Money-Back Guarantee callout ---------------- */
  var GUARANTEE_SHIELD_ICON = '<svg class="aib-guarantee-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 4 5v6c0 5 3.5 9.5 8 11 4.5-1.5 8-6 8-11V5l-8-3z"/><polyline points="9 12 11 14 15 10"/></svg>';

  function buildGuaranteeBox(instance) {
    if (instance.cfg.hideGuaranteeBox) return null;
    var wrap = el('div', { class: 'aib-guarantee' });
    var head = el('div', { class: 'aib-guarantee-head' });
    head.appendChild(el('span', { class: 'aib-guarantee-shield', html: GUARANTEE_SHIELD_ICON }));
    head.appendChild(el('h4', { class: 'aib-guarantee-title', text: '90 Day Money Back Guarantee' }));
    wrap.appendChild(head);
    wrap.appendChild(el('p', {
      class: 'aib-guarantee-body',
      text: "If you're not completely satisfied, simply return the product within 90 days of delivery for a full refund. No hassle or questions asked."
    }));
    return wrap;
  }

  /* ---------------- CTA button ---------------- */

  function buildCta(instance) {
    var cfg = instance.cfg;
    if (cfg.hideCta) return null;
    var btn = el('button', {
      type: 'button',
      class: 'aib-cta',
      dataset: { action: 'add-to-cart', state: 'ready' },
      text: cfg.copy && cfg.copy.ctaLabel ? cfg.copy.ctaLabel : 'Add to cart'
    });
    btn.addEventListener('click', function () { handleAddToCart(instance, btn); });
    return btn;
  }

  function handleAddToCart(instance, btn) {
    var card = instance.cfg.cards.find(function (c) { return c.id === instance.state.selectedId; });
    if (!card) return;
    var mode = instance.state.mode;
    var line = card[mode];
    if (!line || !line.variantId) {
      console.warn('[ai-buybox] no variantId for', card.id, mode);
      return;
    }
    var origLabel = btn.textContent;
    btn.dataset.state = 'loading';
    btn.textContent = 'Adding…';
    btn.disabled = true;

    addToCart(line.variantId, mode === 'subscribe' ? line.sellingPlanId : null)
      .then(function () {
        btn.dataset.state = 'ready';
        btn.disabled = false;
        renderCta(instance, btn);
        openCartDrawer();
        emit('added', Object.assign({ quantity: 1 }, currentSelectionDetail(instance)));
      })
      .catch(function (err) {
        console.error('[ai-buybox] add to cart failed', err);
        btn.dataset.state = 'error';
        btn.textContent = 'Try again';
        setTimeout(function () {
          btn.dataset.state = 'ready';
          btn.disabled = false;
          renderCta(instance, btn);
        }, 1800);
      });
  }

  /* ---------------- state + render ---------------- */

  function setMode(instance, mode) {
    if (mode !== 'onetime' && mode !== 'subscribe') return;
    instance.state.mode = mode;
    render(instance);
  }
  function setSelected(instance, cardId) {
    instance.state.selectedId = cardId;
    render(instance);
  }

  function priceFor(card, mode) {
    var line = card[mode] || {};
    return typeof line.price === 'number' ? line.price : 0;
  }
  function perBrushingFor(card, mode) {
    if (!card.perBrushing) return null;
    var v = card.perBrushing[mode];
    return typeof v === 'number' ? v : null;
  }

  function renderModeTabs(instance) {
    var tabs = instance.dom.modeTabs._aib;
    var mode = instance.state.mode;
    tabs.oneTime.classList.toggle('is-active', mode === 'onetime');
    tabs.subscribe.classList.toggle('is-active', mode === 'subscribe');
    tabs.oneTime.setAttribute('aria-selected', mode === 'onetime' ? 'true' : 'false');
    tabs.subscribe.setAttribute('aria-selected', mode === 'subscribe' ? 'true' : 'false');
    tabs.indicator.style.left = mode === 'onetime' ? '4px' : 'calc(50% + 0px)';
  }

  function renderCards(instance) {
    var mode = instance.state.mode;
    var selectedId = instance.state.selectedId;
    instance.cfg.cards.forEach(function (card, i) {
      var node = instance.dom.bundleNodes[i];
      if (!node) return;
      var ref = node._aib;
      var now = priceFor(card, mode);
      var was = typeof card.retail === 'number' ? card.retail : now;
      var savingsRounded = Math.round(was - now);
      // Total pack count = paid tubes + free tubes (1, 3, 5).
      var totalPack = (card.tubeCountPaid || 0) + (card.tubeCountFree || 0);
      // Header tag and lead label both swap with mode.
      // - subscribe: card-configured headerTag ("Most Popular · Save $30") + leadLabel ("Buy 2 + Get 1") + FREE chip if applicable
      // - onetime:   simple "{N} Pack" for BOTH header and lead, save chip hidden
      if (mode === 'onetime') {
        ref.headerTag.textContent = totalPack + ' Pack';
      } else {
        ref.headerTag.textContent = card.headerTag || '';
      }
      // Rebuild lead label contents fresh each render so we can drop the
      // FREE chip when switching to onetime mode.
      while (ref.lead.firstChild) ref.lead.removeChild(ref.lead.firstChild);
      if (mode === 'onetime') {
        ref.lead.appendChild(document.createTextNode(totalPack + ' Pack'));
      } else {
        ref.lead.appendChild(document.createTextNode(card.leadLabel || ''));
        if (card.tubeCountFree > 0) {
          ref.lead.appendChild(document.createTextNode(' '));
          ref.lead.appendChild(el('span', { class: 'aib-lead-free', text: 'FREE' }));
        }
      }
      ref.priceNow.textContent = formatMoney(now);
      ref.priceWas.textContent = formatMoney(was);
      // Save chip: hidden entirely in OTP mode per request; in subscribe mode
      // shown only if there are actual savings.
      if (mode === 'onetime' || savingsRounded <= 0) {
        ref.saveChip.hidden = true;
      } else {
        ref.saveChip.textContent = 'Save $' + savingsRounded;
        ref.saveChip.hidden = false;
      }
      // Shipping interval ("X tubes · ships every X months"):
      //   - subscribe: full configured ship string ("3 tubes · ships every 3 months")
      //   - onetime:   just "{N} tubes" with no recurring-shipment wording
      if (mode === 'onetime') {
        ref.sub.textContent = totalPack + (totalPack === 1 ? ' tube' : ' tubes');
      } else {
        ref.sub.textContent = card.ship || '';
      }
      ref.sub.hidden = false;
      // Composite tube image: in one-time mode use an explicit
      // `compositeImageUrlOnetime` if provided, otherwise auto-derive
      // by inserting `-onetime` before the file extension. Falls back
      // to the subscribe image if neither resolves.
      if (ref.tubeComposite && card.compositeImageUrl) {
        ref.tubeComposite.src = (mode === 'onetime')
          ? (card.compositeImageUrlOnetime || onetimeImageUrl(card.compositeImageUrl))
          : card.compositeImageUrl;
      }
      var pb = perBrushingFor(card, mode);
      ref.perUnit.textContent = pb != null ? formatMoney(pb) + ' per brushing' : '';
      node.classList.toggle('is-selected', card.id === selectedId);
      node.setAttribute('aria-pressed', card.id === selectedId ? 'true' : 'false');
      // Urgency banner visibility — gate by `showOnlyInModes` (defaults to "every mode").
      if (ref.urgency) {
        var allowedModes = card.urgencyBanner && card.urgencyBanner.showOnlyInModes;
        var showBanner = !Array.isArray(allowedModes) || allowedModes.indexOf(mode) !== -1;
        ref.urgency.hidden = !showBanner;
      }
    });
  }

  function renderBenefits(instance) {
    var panel = instance.dom.benefits;
    if (!panel) return;
    var mode = instance.state.mode;
    var card = instance.cfg.cards.find(function (c) { return c.id === instance.state.selectedId; });
    var isMultiPack = !!(card && (card.tubeCountPaid + (card.tubeCountFree || 0)) > 1);
    var show = mode === 'subscribe';
    panel.hidden = !show;
    if (!show) return;
    var subDiscount = instance.cfg.subDiscountPercent != null ? instance.cfg.subDiscountPercent : 40;
    var refs = panel._aib;
    var title = (instance.cfg.benefits && instance.cfg.benefits.title) ||
                ('Subscribe & Save Up To ' + subDiscount + '% + A Free Gift');
    refs.title.textContent = title;
    [].forEach.call(refs.list.children, function (li) {
      var requires = li.dataset.requiresMultiPack === '1';
      li.hidden = requires && !isMultiPack;
    });
  }

  function renderCta(instance, btn) {
    var node = btn || (instance.dom.cta);
    if (!node) return;
    if (node.dataset.state === 'loading' || node.dataset.state === 'error') return;
    var card = instance.cfg.cards.find(function (c) { return c.id === instance.state.selectedId; });
    if (!card) { node.textContent = 'Add to cart'; return; }
    var mode = instance.state.mode;
    var now = priceFor(card, mode);
    var was = typeof card.retail === 'number' ? card.retail : now;
    var prefix = (instance.cfg.copy && instance.cfg.copy.ctaPrefix) ? instance.cfg.copy.ctaPrefix : 'Add to cart';
    node.textContent = '';
    node.appendChild(document.createTextNode(prefix + ' — ' + formatMoney(now)));
    if (was > now + 0.005) {
      node.appendChild(el('span', { class: 'aib-cta-price-was', text: ' ' + formatMoney(was) }));
    }
  }

  function render(instance) {
    renderModeTabs(instance);
    renderCards(instance);
    renderBenefits(instance);
    renderWelcomeGifts(instance);
    renderCta(instance);
    syncToThemeRadios(instance);
    emit('change', currentSelectionDetail(instance));
  }

  /* ---------------- event emission ----------------
     Fires `aiBuybox:change` whenever the picker state changes (mode toggle,
     card selection), and `aiBuybox:added` after a successful /cart/add.js.
     Theme integration code (e.g. ai-main-product-v2.js) can listen on
     window to keep a sticky ATC bar in sync and fire analytics tracking. */

  function emit(name, detail) {
    try {
      window.dispatchEvent(new CustomEvent('aiBuybox:' + name, { detail: detail || {} }));
    } catch (e) { /* no-op on old browsers */ }
  }

  function currentSelectionDetail(instance) {
    var card = instance.cfg.cards.find(function (c) { return c.id === instance.state.selectedId; });
    if (!card) return null;
    var mode = instance.state.mode;
    var line = card[mode] || {};
    return {
      mode: mode,
      cardId: card.id,
      card: card,
      variantId: line.variantId || null,
      sellingPlanId: mode === 'subscribe' ? (line.sellingPlanId || null) : null,
      price: typeof line.price === 'number' ? line.price : null,
      compareAtPrice: typeof card.retail === 'number' ? card.retail : null
    };
  }

  /* ---------------- theme-section radio sync (adapter mode) ----------------
     When cfg.themeRadioSync === true, the component mirrors its state into
     the existing LIVFRESH theme product-form radio groups so the merchant's
     existing ADD TO CART button (which reads from those radios) keeps
     working untouched. Two radio groups are written:
       - input[type=radio][name$="main-product-variant"]  (value = card.themeRadioProductId)
       - input[type=radio][name$="main-product-plan"]     (value = "sub" or "once")
     Change events are dispatched on each radio that flipped so any listeners
     (price recalc, button label, etc.) update naturally.
  ----------------------------------------------------------------------- */

  function syncToThemeRadios(instance) {
    if (!instance.cfg.themeRadioSync) return;
    var card = instance.cfg.cards.find(function (c) { return c.id === instance.state.selectedId; });
    if (!card) return;

    var variantSel = instance.cfg.themeRadioVariantSelector || 'input[type=radio][name$="main-product-variant"]';
    var planSel    = instance.cfg.themeRadioPlanSelector    || 'input[type=radio][name$="main-product-plan"]';

    var pid = card.themeRadioProductId;
    if (pid != null) {
      var vRadios = document.querySelectorAll(variantSel);
      vRadios.forEach(function (r) {
        var shouldCheck = String(r.value) === String(pid);
        if (r.checked !== shouldCheck) {
          r.checked = shouldCheck;
          if (shouldCheck) {
            r.dispatchEvent(new Event('input', { bubbles: true }));
            r.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }

    var planValue = instance.state.mode === 'subscribe' ? 'sub' : 'once';
    var pRadios = document.querySelectorAll(planSel);
    pRadios.forEach(function (r) {
      var shouldCheck = r.value === planValue;
      if (r.checked !== shouldCheck) {
        r.checked = shouldCheck;
        if (shouldCheck) {
          r.dispatchEvent(new Event('input', { bubbles: true }));
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  /* ---------------- mount ---------------- */

  function mount(root, cfg) {
    if (root._aibMounted) return;
    root._aibMounted = true;
    root.innerHTML = '';

    var instance = {
      root: root,
      cfg: cfg,
      state: {
        mode: cfg.defaultMode === 'onetime' ? 'onetime' : 'subscribe',
        selectedId: cfg.defaultSelectedId || (cfg.cards[cfg.cards.length - 1] || {}).id
      },
      dom: {}
    };

    instance.dom.modeTabs = buildModeTabs(instance);
    var bundlesEl = el('div', { class: 'aib-bundles', role: 'radiogroup' });
    instance.dom.bundleNodes = cfg.cards.map(function (card, i) {
      var node = buildCard(instance, card, i);
      bundlesEl.appendChild(node);
      return node;
    });
    instance.dom.bundles = bundlesEl;
    instance.dom.cta = buildCta(instance);
    instance.dom.trust = buildTrustBadges(instance);
    instance.dom.guarantee = buildGuaranteeBox(instance);
    instance.dom.benefits = buildBenefits(instance);
    instance.dom.welcomeGifts = buildWelcomeGifts(instance);

    root.appendChild(instance.dom.modeTabs);
    root.appendChild(instance.dom.bundles);
    if (instance.dom.benefits) root.appendChild(instance.dom.benefits);
    if (instance.dom.welcomeGifts) root.appendChild(instance.dom.welcomeGifts);
    if (instance.dom.cta) root.appendChild(instance.dom.cta);   /* CTA last — customer scrolls through everything first */
    if (instance.dom.trust) root.appendChild(instance.dom.trust);   /* Trust badges directly below CTA */
    if (instance.dom.guarantee) root.appendChild(instance.dom.guarantee);   /* 90-day guarantee callout below trust badges */

    render(instance);
    instances.push(instance);
    return instance;
  }

  /* ---------------- public API ---------------- */

  window.aiBuybox = {
    mount: function (root, cfg) { return mount(root, cfg || window.AI_BUYBOX_CONFIG); },
    getInstances: function () { return instances.slice(); },
    addCurrentSelectionToCart: function () {
      var inst = instances[0];
      if (!inst) return Promise.reject(new Error('no buybox mounted'));
      var card = inst.cfg.cards.find(function (c) { return c.id === inst.state.selectedId; });
      var line = card && card[inst.state.mode];
      if (!line || !line.variantId) return Promise.reject(new Error('no variant for current selection'));
      return addToCart(line.variantId, inst.state.mode === 'subscribe' ? line.sellingPlanId : null)
        .then(function (r) {
          openCartDrawer();
          emit('added', Object.assign({ quantity: 1 }, currentSelectionDetail(inst)));
          return r;
        });
    },
    /* Read current selection state synchronously — useful when wiring a
       sticky ATC bar that needs the current variant before any event fires. */
    getState: function () {
      var inst = instances[0];
      return inst ? currentSelectionDetail(inst) : null;
    }
  };

  /* ---------------- init ---------------- */

  function init() {
    var cfg = window.AI_BUYBOX_CONFIG;
    if (!cfg) {
      console.warn('[ai-buybox] window.AI_BUYBOX_CONFIG not found; nothing to mount.');
      return;
    }
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) {
      console.warn('[ai-buybox] no .ai-buybox element found on the page.');
      return;
    }
    roots.forEach(function (r) { mount(r, cfg); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
